export type CustomerAvatarGender = 'female' | 'male';
export type CustomerAvatarAge = '20-30' | '30-40' | '40-50' | '50-60' | '60+';

export const CUSTOMER_AVATAR_AGES: CustomerAvatarAge[] = ['20-30', '30-40', '40-50', '50-60', '60+'];
export const CUSTOMER_AVATAR_COUNT = 20;

export function normalizeCustomerAvatarGender(value: unknown): CustomerAvatarGender {
  return value === 'male' ? 'male' : 'female';
}

export function normalizeCustomerAvatarAge(value: unknown): CustomerAvatarAge {
  return CUSTOMER_AVATAR_AGES.includes(value as CustomerAvatarAge) ? value as CustomerAvatarAge : '50-60';
}

export function normalizeCustomerAvatarIndex(value: unknown, fallback = 1): number {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(CUSTOMER_AVATAR_COUNT, Math.max(1, Math.round(n)));
}

export function getCustomerAvatarUrl(
  gender: CustomerAvatarGender,
  age: CustomerAvatarAge,
  index: number,
): string {
  return `/avatars/${gender}-${age}-${normalizeCustomerAvatarIndex(index)}.jpg`;
}
